import { RequestConfig } from 'common/types/api'

export const TRANSFER_REQUEST_CONFIG: RequestConfig = {
  get: { method: 'GET', url: '/partial-transfer' },
  create: { method: 'POST', url: '/partial-transfer' },
  delete: { method: 'DELETE', url: '/partial-transfer' },
  getLatestCostPerKg: { method: 'GET', url: '/partial-transfer/latest-cost-per-kg' },
  getRecentSize: { method: 'GET', url: '/partial-transfer/recent-size' },
}
